import type { App } from "vue";
import { createRouter, createWebHashHistory, RouteRecordRaw } from "vue-router";
import { basicRoutes, LoginRoute, PAGE_NOT_FOUND_ROUTE } from "./basic";
import { createProgressGuard } from "./guards/progressGuard";
import { createPermissionGuard } from "./guards/permissionGuard";
import { createTitleGuard } from "./guards/titleGuard";

export { PAGE_NOT_FOUND_ROUTE };

const modules: Record<string, any> = import.meta.glob("./modules/**/*.ts", {
  eager: true,
});
const routeModuleList: RouteRecordRaw[] = [];
Object.keys(modules).forEach((key) => {
  const mod = modules[key].default || {};
  const modList = Array.isArray(mod) ? [...mod] : [mod];
  routeModuleList.push(...modList);
});

export const asyncRoutes = [
  PAGE_NOT_FOUND_ROUTE,
  LoginRoute,
  ...routeModuleList,
];

const WHITE_NAME_LIST: string[] = [];
const getRouteNames = (array: any[]) =>
  array.forEach((item) => {
    WHITE_NAME_LIST.push(item.name);
    getRouteNames(item.children || []);
  });
getRouteNames(basicRoutes);

// app router
export const router = createRouter({
  history: createWebHashHistory(import.meta.env.VITE_PROJECT_ALIAS),
  routes: basicRoutes as unknown as RouteRecordRaw[],
  strict: true,
  scrollBehavior: () => ({ left: 0, top: 0 }),
});

export function resetRouter() {
  router.getRoutes().forEach((route) => {
    const { name } = route;
    if (name && !WHITE_NAME_LIST.includes(name as string)) {
      router.hasRoute(name) && router.removeRoute(name);
    }
  });
}

export function setupRouter(app: App<Element>) {
  app.use(router);

  createProgressGuard(router);
  createPermissionGuard(router);
  createTitleGuard(router);
}
